"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClickableAreaStyled = exports.ClockContainer = exports.ExpandingBoundingBoxStyled = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _hotspot = require("../../hotspot.constants");

var _hotspotGlobal = require("../../hotspot.global.styles");

var _boundingBox = require("../../components/bounding-box");

var _hotspot2 = _interopRequireDefault(require("../../hotspot.styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var ExpandingBoundingBoxStyled = (0, _styledComponents.default)(_boundingBox.ExpandingBoundingBox).withConfig({
  displayName: "clockstyles__ExpandingBoundingBoxStyled",
  componentId: "sc-4e9qoc-0"
})([""]);
exports.ExpandingBoundingBoxStyled = ExpandingBoundingBoxStyled;

var ClockContainer = _styledComponents.default.div.attrs(function (_ref) {
  var iconPosition = _ref.iconPosition;
  return {
    style: {
      left: "".concat(iconPosition.left, "%"),
      top: "".concat(iconPosition.top, "%")
    }
  };
}).withConfig({
  displayName: "clockstyles__ClockContainer",
  componentId: "sc-4e9qoc-1"
})(["height:12em;position:absolute;transform:", ";width:12em;.circle-wrapper{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);.ring{transition:r 0.3s;}}.clock-svg{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);.ring{transition:r 0.3s;}}.clock-svg{transition:all 0.3s;transform:translate(-50%,-50%) rotate(-90deg);}"], _hotspotGlobal.translateXY);

exports.ClockContainer = ClockContainer;
var hoverState = "\n  ".concat(ExpandingBoundingBoxStyled, " {\n    ").concat(_boundingBox.ExpandingBoundingBoxHoverState, "\n  }\n\n  .clock-svg {\n    height: 68%;\n    width: 68%;\n  }\n  .svg-0 {\n    .ring {\n      r: 34%;\n    }\n  }\n  .svg-1 {\n    .ring {\n      r: 46%;\n    }\n  }\n");
var ClickableAreaStyled = (0, _styledComponents.default)(_hotspot2.default).withConfig({
  displayName: "clockstyles__ClickableAreaStyled",
  componentId: "sc-4e9qoc-2"
})(["", ""], function (_ref2) {
  var disableHover = _ref2.disableHover;
  return !disableHover && (0, _styledComponents.css)(["&:hover,&", "{", "}", ""], _hotspot.focusVisible, hoverState, function (_ref3) {
    var previewHoverState = _ref3.previewHoverState;
    return previewHoverState && hoverState;
  });
});
exports.ClickableAreaStyled = ClickableAreaStyled;